<template>
  <div class="findPw">
    <FindPwBody/>
    <FindPwFooter/>
  </div>
</template>
<script>
import FindPwBody from "./findPwBody";
import FindPwFooter from "./findPwFooter";

export default {
  name: 'FindPw',
  components: {
    FindPwBody,
    FindPwFooter
  }
}
</script>